<app-card-layout-content class="cookie-disabled-page">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <app-feedback-failure-svg-icon></app-feedback-failure-svg-icon>
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Ops! Cookie disabilitati</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <div class="cookie-disabled-page__description">
        <p i18n>Le tue impostazioni per i Cookie risultano essere disabilitate.</p>
        <p i18n>Per poter accedere abilita i cookie dalle impostazioni del tuo browser predefinito.</p>
      </div>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
  <div class="p-d-flex p-flex-column p-ai-center p-mt-auto">
    <span i18n>Hai bisogno di supporto?</span>
    <a class="p-mt-1 p-text-bold" [href]="'tel:' + helplineNumber" i18n>Contatta l’assistenza</a>
  </div>
</app-card-layout-content>
